<template>
  <div v-if="item && type && info">
    <div class="claim-card">
      <div class="user-name d-flex p-3">
        <div class="d-flex flex-column">
          <a class="bg-img d-block background-image">
            <a-avatar @click="routeToProfile()" :style="{ color: ' #ffffff !important', 'background-color': '#C997C5' }" :size="70" :src="item.picture" class="text-capitalize">
              {{ type === "hospital" ? item.hospital_name[0] : type === 'hcp' ? item.full_name[0] : item.clinic_name[0] }}
            </a-avatar>
          </a>
          <div class="rating-cont">
            <div class="review-star">
              <ReviewStar :rating="item.overall_rating ? item.overall_rating : 0" />
            </div>
            <span class="rating-text">{{ item.overall_rating ? item.overall_rating : 0 }} stars</span>
            <span class="rating-text">{{ item.no_of_reviews ? item.no_of_reviews : 0 }} reviews</span>
          </div>
        </div>
        <div class="divider" />
        <div class="right-items">
          <div class="text-left first-cont" :style="profileButton? {} : {flex: 1}">
            <div class="bold-text cp" @click="routeToProfile()" :style="{ color: '#0F1734', 'font-weight': '700', 'font-size': '20px', 'flex-wrap': 'wrap', width: '200px' }">
              {{ type === 'hcp' ? item.full_name : type == "hospital" ? item.hospital_name : item.clinic_name }}
            </div>
            <div class="tag">
              <div class="tag-ele rounded" :style="{ background: getPrimary50Color() }">
                <p :style="{ color: getPrimaryColor(), 'font-weight': '700', 'font-size': '12px', 'line-height': '14px' }" class="m-0 doc-loc">
                  {{ type === 'hcp' ? item.ohcp_speciality : type == "hospital" ? item.hospital_type : item.clinic_type }}
                </p>
              </div>
            </div>
          </div>

          <div class="meet-others">
            <div class="card-address">
              <div class="card-number">
                <img src="../../../assets/images/addphy-phone.png" alt="phone-logo" />
                <div>
                  <strong>{{ item.phone_number }}</strong>
                </div>
              </div>
              <div class="card-location">
                <img src="../../../assets/images/addphy-location.png" alt="location" />
                <div class="location-complete">
                  <span v-if="type !== 'hcp'" class="location-fix" :style="{ color: '#94A3B8' }">
                    {{ item.city ? item.city : "" }} {{ item.state ? "," + item.state : "" }}
                    {{
                      item.street
                        .split(" ")
                        .filter(sttr => sttr !== "None,")
                        .join(" ")
                    }}
                  </span>
                  <span v-if="type === 'hcp'" class="location-fix" :style="{ color: '#94A3B8' }">
                    {{  item.address }}
                  </span>
                </div>
              </div>
              <div v-if="type !== 'hcp'" class="card-distance">
                <div :style="{ 'margin-top': '12px' }"><strong>0 miles away</strong></div>
              </div>
            </div>
          </div>
          <div v-if="profileButton" class="meet-others">
            <a-button
              @click="routeToProfile()"
              :loading="loading"
              :style="{ background: getPrimaryColor(), 'pointer-events': 'all', 'font-size': '14px', 'border-radius': '6px', padding: '12px 24px' }"
              class="font-white primary-button btn-width"
            >
              View Profile
            </a-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewStar from "../../Users/Doctor/reviewstarforcircle.vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faThumbsUp, faCrown } from "@fortawesome/pro-solid-svg-icons"
library.add(faThumbsUp, faCrown)
export default {
  name: "AffiliatedCard",
  props: {
    item: Object,
    type: String,
    info: Object,
    profileButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return { loading: false }
  },
  components: { ReviewStar },
  created() {
    console.warn("AffiliatedCard.vue is created")
  },
  methods: {
    routeToProfile() {
      if(this.type !== 'hcp'){
        this.loading = true
      }
      let data = { ...this.item, role: this.type }
      switch (this.type) {
        case "hcp":
          window.location.href = `${process.env.SSO_BASE_URL}${this.item.url}`
          // this.viewEntityProfile({ ...this.item, role: "hcp", id: this.info.ohcp })
          break
        case "hospital":
          this.viewEntityProfile({ ...this.item, role: "hospital" })
          break
        case "clinic":
          this.viewEntityProfile(data)
          break
        case "nfp":
          this.viewEntityProfile(data)
          break
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-width {
  @media screen and (max-width: 900px) {
    width: 100%;
  }
}

.profile-btn {
  padding: 8px 16px;
  background: #062b54;
  border-radius: 6px;
  display: flex;
  align-items: center;
}

.crown-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 8px;
  gap: 4px;
  width: 30px;
  height: 22px;
  background: #fff0d6;
  border-radius: 4px;
  justify-content: center;
}

.tags-cont {
  display: flex;
  gap: 8px;
}

.rec-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  width: 115px;
  height: 22px;
  background: #f1edff;
  border-radius: 4px;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  color: #906eff;
}
.claim-card {
  border: 1px solid #e2e8f0;
  width: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);

  .user-name {
    height: 178px;
    padding: 24px !important;

    @media screen and (max-width: 900px) {
      height: 100%;
      position: relative;
    }

    .rating-text {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
      /* or 117% */

      text-align: center;

      /* Gray/900 */

      color: #0f1734;
    }

    .rating-cont {
      margin-top: 11px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0px;
      gap: 4px;
      margin-left: 5px;
      width: 88.53px;
      height: 48px;
    }

    .bg-img {
      position: relative;
      // border: 1px solid #ccc;
      // min-width: 100px;
      max-width: 100px;
      min-height: 70px;
      max-height: 70px;
      width: 70px;
      height: 70px;
      border-radius: 50%;
      display: inline-block;
      margin-left: 11.5px;
      margin-right: 35.5px;

      .rating-badge {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 20%);
        font-size: 15px;
        border-radius: 20px;
        width: 55%;
      }
    }
  }

  .user-address {
    line-height: 15px;
  }

  .dovemed-card-footer {
    border-top: 1px solid rgba(0, 0, 0, 0.125);

    span {
      font-size: 12px;
    }
  }
}

.background-image {
  background-position: center !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
}

.divider-mob {
  display: none;

  @media screen and (max-width: 900px) {
    height: inherit;
    border: 1px solid #cbd5e1;
    margin-top: -24px;
    background: #cbd5e1;
  }
}

.divider {
  height: 178px;
  border: 1px solid #cbd5e1;
  margin-top: -24px;
  background: #cbd5e1;

  @media screen and (max-width: 900px) {
    height: inherit;
    position: absolute;
    left: 128px;
  }
}

.first-cont {
  width: 213px;
  display: flex;
  flex-direction: column;
  gap: 17px;

  @media screen and (max-width: 900px) {
    width: 158px;
  }
}

.right-items {
  display: flex;
  width: 100%;
  // justify-content: space-between;
  // gap: 24px;
  overflow: none !important;
  margin-left: 24px;
  font-size: 14px;

  @media screen and (max-width: 900px) {
    display: block;
    width: 186px;
    margin-left: 0px;
  }
}

.meet-others {
  display: flex;
  align-items: center;
  width: 213px;
  @media screen and (max-width: 700px) {
    margin-top: 32px;
  }

  button {
    margin-right: 24px;
    font-size: 14px;
    border-radius: 6px;
    padding: 12px 24px;
    width: 126px;
    height: 48px;
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
  }
}

.card-number {
  display: flex;
  flex-direction: row;
  align-items: end;
  padding: 0px;
  gap: 6px;
  width: 126px;
  height: 24px;

  p {
    margin-bottom: 0;
    margin-left: 0.03px;
    color: #0f1734 !important;
  }
}

.card-location {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  width: 152px;
  // height: 42px;
  margin-top: 13.5px;
  gap: 6px;
}

.location-fix {
  display: flex;
  max-width: 152px;
  flex-wrap: wrap;
  word-break: break-all;
}

.location-complete {
  // height: 42px;

  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #94a3b8;
  margin-top: 7px;

  @media screen and (max-width: 700px) {
    height: 100%;
  }
}

.location-complete p {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #94a3b8;
  margin-bottom: 0;
  align-items: start;
  display: flex;
  margin-left: 8.5px;
}

.card-distance {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px 0px 0px 28px;
  // height: 21px;
  // margin-top: 12px;
  display: flex;
  align-items: start;
}

.tag {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 16px;

  .tag-ele {
    padding: 4px 8px;
    display: inline-block;
    font-weight: 700;
    font-size: 10px;
    margin-right: 5px;
    // height: 22px;
  }
}
.doc-loc {
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/components/home/provider/AffiliatedCard.vue